module.exports = __webpack_public_path__ + "img/super-soldiers.4292c3c5.jpg";